import { config } from '@/config'
import { setAuthData } from '@/helpers'
import { z } from 'zod'

export const generateAccessByPersonalToken = async ({
  personalToken,
}: {
  personalToken: string
}) => {
  const result = await fetch(
    `${config.services.api}/core/login/personal-token/access`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        personalToken,
      }),
    },
  )

  if (!result.ok) {
    const data = await result.json()
    throw new Error(
      data.message ??
        'Could not generate an access token from the provided personal token',
    )
  }

  const { accessToken } = z
    .object({ accessToken: z.string() })
    .parse(await result.json())

  setAuthData({ accessToken: accessToken, personalToken: personalToken })
  return { accessToken, personalToken }
}
